import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect, useCallback } from 'react';
import { ReactSortable } from 'react-sortablejs';
import { Form, Spin } from 'antd';
import { InfoCircleOutlined, } from '@ant-design/icons';
import { txt } from 'libs/i18n';
import { fetchCurrentTeamTags } from 'api/team-api';
import { useSession } from 'components/Authenticated';
import styles from './style.module.less';
import ProjectItem from '../ProjectItem';
const ProjectSorter = ({ form, projectList }) => {
    const [sortedProjects, setSortedProjects] = useState(projectList);
    const [teamTags, setTeamTags] = useState('loading');
    const { session } = useSession();
    const handleProjectOrderChange = useCallback((newOrder) => {
        setSortedProjects(newOrder);
        form.setFieldValue('projectIds', newOrder.map((project) => project.id));
    }, [form]);
    const fetchTags = async () => {
        const tags = await fetchCurrentTeamTags(session.connection);
        setTeamTags(tags);
    };
    useEffect(() => {
        void fetchTags();
    }, []);
    return (_jsx("div", { children: _jsx(Form.Item, { name: "projectIds", label: `${txt('projectsOrder')}`, tooltip: {
                title: txt('dragAndDropToReorderProjects'),
                icon: _jsx(InfoCircleOutlined, { color: "info" }),
            }, labelCol: { span: 24, className: styles.label }, children: teamTags === 'loading'
                ? _jsx(Spin, {})
                : (_jsx(ReactSortable, { list: sortedProjects, setList: handleProjectOrderChange, className: styles.projectList, chosenClass: styles.projectChosen, animation: 150, children: sortedProjects.map((project, index) => (_jsx(ProjectItem, { project: project, avatarLabel: (index + 1).toString(), teamTags: teamTags, isDraggable: true, draggableClassName: styles.projectDragIcon }, project.id))) })) }) }));
};
export default ProjectSorter;
